<template>
    <div class="learnlistBox">
        <div v-if="showLoading">
            <van-overlay :show="showLoading"/>
            <div class="loadinglist">
                <van-loading v-if="showLoading" size="24px" vertical>加载中...</van-loading>
            </div>
        </div>
        <div v-else class='learnlist'>
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text=" 一 已经到底了，更多内容即将上线 一 "
                :immediate-check="false"
                ref="list"
                @load="onLoad"
                v-if="evaluationlist && evaluationlist.length"
            >
                <ul>
                    <li  v-for="(item,index) in evaluationlist" :key="index" @click="evaluationMsg(item)">
                        <div class="learning-list-left">
                            <img class="learning-list-left-img" :src="item.assessCoverimg" alt="">
                            <!-- 千万别删！！！ -->
                            <!-- <div class="_clear">
                                <p class="learning-list-left-new" v-if="item.isNew">
                                    <img src="../../../assets/images/learning/new1.png" alt="">
                                    <span>NEW</span>
                                </p>
                                注释开始
                                <p class="learning-list-left-rules1" v-if="item.isNew && item.isVali">
                                    <img src="../../../assets/images/learning/rules1.png" alt="">
                                    <span>已过期</span>
                                </p>
                                注释结束
                                <p class="learning-list-left-rules learning-list-left-overdue" v-if="!item.isNew && item.isValid">
                                    <img src="../../../assets/images/learning/overdue.png" alt="">
                                    <span>已过期</span>
                                </p>
                            </div> -->
                        </div>
                        <div class="learning-list-right">
                            <h4>{{item.assessName}}</h4>
                            <!-- <p class="learning-list-right-validity">长期有效</p> -->
                            <p class="learning-list-right-validity learning-list-right-validity2" v-if="learnValidity">有效期至：{{formatTime(item.validEndTime)}}</p>
                            <!-- 千万别删！！！ -->
                            <!-- <p v-if="item.modelType" class="learning-list-right-lable learning-list-right-lable3 _clear">
                                <span>{{item.modelType===1?'素质':'专业'}}</span>
                            </p> -->
                        </div>
                    </li>
                </ul>
            </van-list>
            <div class="noContent" v-else>
                <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/learning/noContent.png"/>
                <p class="trainging-noContent">您还没有学习内容</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'',
    data () {
        return {
            showLoading: true,
            loading:false,
            finished:false,
            filter: {
                pageNum: 1,
                pageSize: 20,
            },
            evaluationlist:[],
            total: 0,
            isValid:null,
        };
    },
    props: {
        learnValidity: {
            type: Boolean,
            default: false
        }
    },
    components: {
    },
    methods: {
        /**
         * 上拉加载
         */
        onLoad() {
            this.filter.pageNum = this.filter.pageNum*1 + 1
            this.getEvaluationList('reachBottom')
        },
        formatTime(val) {
            if(val){
                return val.split(' ')[0].split('-').join('.');
            }
        },
        evaluationMsg(item){
            this.$router.push({
                path: '/humanResting/hrDetails',
                query: {
                    id:item.id,
                    isValid:item.isValid,
                    refId:item.refId,
                    refType:item.refType,
                    backType:3,
                }
            })
        },
        selectcheck(value){
            this.filter={
                pageNum: 1,
                pageSize: 20
            };
            this.isValid=value;
            this.getEvaluationList();
        },
        getEvaluationList(type) {
            let params = this.filter;
            let data={
                isValid:this.isValid,
            }
            this.$api.learning.evaluationAssess({ params,data }).then(({ data }) => {
                this.showLoading = false;
                if(data){
                    if (type === "reachBottom") {
                        this.evaluationlist = this.evaluationlist.concat(data.list);
                    } else {
                        this.evaluationlist = data.list || [];
                    }
                    this.total = data.total;
                    // 加载状态结束
                    this.loading = false;
                    // 数据全部加载完成
                    this.finished = data.isLastPage;
                }
                
           
            });
        },

    },

    mounted(){
      
    },
}

</script>
<style lang='less' scoped>
@import '../css/learnlist.less';
</style>